import React from 'react';
import airbnb from '../../../images/logos/airbnb.png';
import google from '../../../images/logos/google.png';
import netflix from '../../../images/logos/netflix.png';
import slack from '../../../images/logos/slack.png';
import uber from '../../../images/logos/uber.png';

const CompanyInfo = () => {
    return (
        <div className='container mb-5 pb-5'>
        <div className='row px-0 d-flex justify-content-between'>
            <div className='col-md-2 col-6 mb-md-0 mb-3 text-center'>
                <img style={{ height: '40px' }} src={slack} alt="" />
            </div>
            <div className='col-md-2 col-6 mb-md-0 mb-3 text-center'>
                <img style={{ height: '45px' }} src={google} alt="" />
            </div>

            <div className='col-md-2 col-6 mb-md-0 mb-3 text-center'>
                <img style={{ height: '45px' }} src={uber} alt="" />
            </div>
            <div className='col-md-2 col-6 mb-md-0 mb-3 text-center'>
                <img style={{ height: '50px' }} src={netflix} alt="" />
            </div>
            <div className='col-md-2 col-6 mb-md-0 mb-3 text-center'>
                <img style={{ height: '50px' }} src={airbnb} alt="" />
            </div>
        </div>
        </div>
    );
};

export default CompanyInfo;